<template>
  <div class="sort-box">
    <div class="title-box">
        <span class="text">Sort By</span>
        <span class="btn" @click="reset">Reset</span>
    </div>
    <div :class="['select-box', {'open':boxConfig.soryBy}]">
        <el-radio-group v-model="soryBy" text-color="#000" fill="#aa0bc0">
            <el-radio class="radio" :label="0">Recommended</el-radio>  <br>
            <el-radio class="radio" :label="1">Distance shortest to furthest</el-radio>  <br>
            <el-radio class="radio" :label="2">Free Delivery</el-radio>  <br>
            <el-radio class="radio" :label="3">New on All Eat</el-radio>  <br>
        </el-radio-group>
    </div>
    <div class="title-box" @click="boxConfig.star=!boxConfig.star">
        <span class="text">Rating</span>
        <i class="icon el-icon-arrow-down" ></i>
    </div>
    <div :class="['select-box', {'open':boxConfig.star}]">
        <el-radio-group v-model="star" text-color="#000" fill="#aa0bc0">
            <el-radio class="radio radio-r" :label="5">
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
            </el-radio>  <br>
            <el-radio class="radio radio-r" :label="4">
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
            </el-radio>  <br>
            <el-radio class="radio radio-r" :label="3">
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
            </el-radio>  <br>
            <el-radio class="radio radio-r" :label="2">
                <i class="el-icon-star-on" ></i>
                <i class="el-icon-star-on" ></i>
            </el-radio>
        </el-radio-group>
    </div>
    <div class="title-box" @click="boxConfig.orderType=!boxConfig.orderType">
        <span class="text">Order Type</span>
        <i class="icon el-icon-arrow-down" ></i>
    </div>
    <div :class="['select-box', {'open':boxConfig.orderType}]">
        <el-radio-group v-model="orderType" text-color="#000" fill="#aa0bc0">
            <el-radio class="radio radio-r" :label="0">Pre-order</el-radio>  <br>
            <el-radio class="radio radio-r" :label="1">Delivery</el-radio>  <br>
            <el-radio class="radio radio-r" :label="2">Pick-up</el-radio>  <br>
            <el-radio class="radio radio-r" :label="3">Dine-in</el-radio>  <br>
        </el-radio-group>
    </div>
    <div class="title-box" @click="boxConfig.specOffer=!boxConfig.specOffer">
        <span class="text">Special Offers</span>
        <i class="icon el-icon-arrow-down" ></i>
    </div>
    <div :class="['select-box', {'open':boxConfig.specOffer}]">
        <el-radio-group v-model="specOffer" text-color="#000" fill="#aa0bc0">
            <el-radio class="radio radio-r" :label="0">Free Delivery</el-radio>  <br>
            <el-radio class="radio radio-r" :label="1">50% Off</el-radio>  <br>
            <el-radio class="radio radio-r" :label="2">20% Off</el-radio>  <br>
            <el-radio class="radio radio-r" :label="3">10% Off</el-radio>  <br>
        </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            soryBy: 0,
            star: '',
            orderType: '',
            specOffer: '',
            boxConfig: {
                soryBy: true,
                star: true,
                orderType: true,
                specOffer: true,
            }
        }
    },
    mounted() {

    },
    methods: {
        reset() {
            this.soryBy = 0;
            this.star = '';
            this.orderType = '';
            this.specOffer = '';
        }
    }
}
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #09CA6A;
$yellowColor: #ffa132;
.sort-box {
    width: 100%;
    border-radius: 8px;
    padding: 0 4px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);

    .title-box {
        padding: 10px 6px 10px 11px;
        display: flex;
        font-size: 15px;
        font-weight: 600;
        align-items: center;
        color: #000;
        border-top: 1px solid rgba(0, 0, 0, 0.42);
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
        &:nth-child(1) {
            border-top: none;
        }
        .text {
            flex: 1;
            cursor: pointer;
        }
        
        .btn {
            display: inline-block;
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border-radius: 4px;
            background: $greenColor;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
            transition: all ease-in-out .2s;
            font-size: 15px;
            &:hover {
                background: #1daa63;
            }
        }
        .icon {
            color: $mainColor;
            cursor: pointer;
        }
    }
    .select-box {
        height: 0;
        overflow: hidden;
        padding: 0 15px 0 30px;
        transition: all ease-in-out .5s;
        .radio {
            font-size: 14px;
            color: #222222!important;
            margin-bottom: 8px;
            font-size: 18px;
            .el-icon-star-on {
                color: #ff8000;
                font-size: 18px;
            }
        }
        :deep(.el-radio.radio.is-checked) {
            .el-radio__input.is-checked .el-radio__inner {
                background: $mainColor;
                border-color: $mainColor;

                &::after {
                    display: none;
                }
            }
            

            .el-radio__label {
                color: #000;
                font-weight: bold;
            }
        }

        :deep(.el-radio.radio-r) {
                .el-radio__input .el-radio__inner {
                    border-radius: 0;
                }
            }
    }
    .open {
        padding: 15px 15px 15px 30px;
        height: 130px;
    }
}
</style>
